export const runForm = () => {
  const form = document.getElementById("wpcf7-f220-p421-o1");
  const hiddenButton = document.querySelector(".amthal-download-guide");

  if (!form) return;

  document.addEventListener("wpcf7mailsent", function (event) {
    if ("220" == event.detail.contactFormId) {
      form.style.display = "none";
      hiddenButton.classList.toggle("hidden");
    } else {
      return;
    }
  });
};
